import { getMessageFromError } from '../utils/functions'

const PREFIX = 'admin/organization'
const FAQ_PREFIX = 'admin/faq'
const STAY_PREFIX = 'admin/stay'
const CONTACT_PREFIX = 'admin/organization-contact'
const DONATION_PREFIX = 'admin/organization-donation'
const UPDATE_PREFIX = 'admin/organization-updates'
const MEMBER_PREFIX = 'admin/organization-member'
const USER_PREFIX = 'admin/user'
export default {
  /* -------------------------------------------------------------------------- */
  /*                               Create Gurudwara                               */
  /* -------------------------------------------------------------------------- */
  async create({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${PREFIX}/create`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message,
        data: res.data.data
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                List Gurudwara                             */
  /* -------------------------------------------------------------------------- */
  async get({ commit }, params) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/list`, { params })
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'records',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'total',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Delete Gurudwara                               */
  /* -------------------------------------------------------------------------- */
  async delete({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.delete(`/${PREFIX}/delete/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Update Gurudwara                               */
  /* -------------------------------------------------------------------------- */
  async update({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/update/${id}`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Update Sarai                               */
  /* -------------------------------------------------------------------------- */
  async updateSarai({ commit }, { data }) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${STAY_PREFIX}/update`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Show Gurudwara                               */
  /* -------------------------------------------------------------------------- */
  async show({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'record',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                             Manage Index Number                            */
  /* -------------------------------------------------------------------------- */
  async manageIndexNumber({ commit }, { id, featured_index }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/manage-featured-index/${id}`, { featured_index })
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      console.error(error)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                Sarai List                               */
  /* -------------------------------------------------------------------------- */
  async saraiList({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${STAY_PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Update Status                               */
  /* -------------------------------------------------------------------------- */
  async updateStatus({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/change-status/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATUS', { id, status: res.data.data.is_active, type: 'is_active' })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                        featuredStatus for Gurudwara                        */
  /* -------------------------------------------------------------------------- */
  async featuredStatus({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/change-featured-status/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATUS', { id, status: res.data.data.is_featured, type: 'is_featured' })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /**--------
   * Find an valid admin
   */
  async findValidOrgAdmin({ commit }, { email, mobile_number, organizationId }) {
    try {
      commit('SET_STATE', {
        action: 'validAdminLoading',
        data: true
      })

      const res = await this.$http.get(`${USER_PREFIX}/valid-org-admin`, {
        params: {
          email,
          mobile_number,
          organizationId
        }
      })
      commit('SET_STATE', {
        action: 'validAdminLoading',
        data: false
      })

      console.log(res, '=========RESPONSE')

      return {
        message: res.data.message,
        validAdmin: res.data.validOrgAdmin || {}
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'validAdminLoading',
        data: false
      })

      console.log(error, '======ERROR THIS ONE')
      // Manage Error
      const { message } = getMessageFromError(error)
      return {
        message,
        validAdmin: null
      }
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                              Invite Guru Admin                             */
  /* -------------------------------------------------------------------------- */
  async inviteAdmin({ commit }, data) {
    commit('SET_STATE', {
      action: 'createAdminLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${PREFIX}/invite-organization`, data)
      commit('SET_STATE', {
        action: 'createAdminLoading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createAdminLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                Gurudwara Service Request List ( User Added )               */
  /* -------------------------------------------------------------------------- */
  async getServices({ commit }, params) {
    commit('SET_STATE', {
      action: 'serviceListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`admin/organization/service-request/list`, { params })
      commit('SET_STATE', {
        action: 'serviceListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'serviceRecords',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'serviceTotal',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'serviceFilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'serviceListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                 FAQ Create                                 */
  /* -------------------------------------------------------------------------- */
  async faqCreate({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${FAQ_PREFIX}/create`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                  FAQ List                                  */
  /* -------------------------------------------------------------------------- */
  async faqGet({ commit }, params) {
    commit('SET_STATE', {
      action: 'faqListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${FAQ_PREFIX}/list`, { params })
      commit('SET_STATE', {
        action: 'faqListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'faqRecords',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'faqTotal',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'faqFilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'faqListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                 FAQ Delete                                 */
  /* -------------------------------------------------------------------------- */
  async faqDelete({ commit }, id) {
    commit('SET_STATE', {
      action: 'faqListLoading',
      data: true
    })
    try {
      const res = await this.$http.delete(`/${FAQ_PREFIX}/delete/${id}`)
      commit('SET_STATE', {
        action: 'faqListLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'faqListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                 FAQ Bulk Delete                                 */
  /* -------------------------------------------------------------------------- */
  async faqBulkDelete({ commit }, faq) {
    commit('SET_STATE', {
      action: 'faqListLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`/${FAQ_PREFIX}/multi-delete`, faq)
      commit('SET_STATE', {
        action: 'faqListLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'faqListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                 FAQ update                                 */
  /* -------------------------------------------------------------------------- */
  async faqUpdate({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${FAQ_PREFIX}/update/${id}`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                 FAQ Detail                                 */
  /* -------------------------------------------------------------------------- */
  async faqShow({ commit }, id) {
    commit('SET_STATE', {
      action: 'faqListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${FAQ_PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'faqListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'faqRecord',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'faqListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                      Contact Us Crete Gurudwara Based                      */
  /* -------------------------------------------------------------------------- */
  async contactCreate({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${CONTACT_PREFIX}/create`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                        list contacts Gurudwara Based                       */
  /* -------------------------------------------------------------------------- */
  async contactGet({ commit }, params) {
    commit('SET_STATE', {
      action: 'contactListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${CONTACT_PREFIX}/list`, { params })
      commit('SET_STATE', {
        action: 'contactListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'contactRecords',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'contactTotal',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'contactFilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'contactListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Contact Delete                               */
  /* -------------------------------------------------------------------------- */
  async contactDelete({ commit }, id) {
    commit('SET_STATE', {
      action: 'contactListLoading',
      data: true
    })
    try {
      const res = await this.$http.delete(`/${CONTACT_PREFIX}/delete/${id}`)
      commit('SET_STATE', {
        action: 'contactListLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'contactListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                 Contact Bulk Delete                           */
  /* -------------------------------------------------------------------------- */
  async contactBulkDelete({ commit }, contact) {
    commit('SET_STATE', {
      action: 'contactListLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`/${CONTACT_PREFIX}/multi-delete`, contact)
      commit('SET_STATE', {
        action: 'contactListLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'contactListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Contact Update                               */
  /* -------------------------------------------------------------------------- */
  async contactUpdate({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${CONTACT_PREFIX}/update/${id}`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                              Get Detail Contat                             */
  /* -------------------------------------------------------------------------- */
  async contactShow({ commit }, id) {
    commit('SET_STATE', {
      action: 'contactListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${CONTACT_PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'contactListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'contactRecord',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'contactListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                             Youtube Live Manage                            */
  /* -------------------------------------------------------------------------- */
  async youtubeLiveHandle({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/go-live/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      // commit('SET_STATUS', { id, status: res.data.data.go_live_on_youtube, type: 'is_active' })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async graphicsUpdate({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${PREFIX}/thumbnail/update/${id}`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                      Donation Us Crete Gurudwara Based                      */
  /* -------------------------------------------------------------------------- */
  async donationCreate({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${DONATION_PREFIX}/create`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                        list donations Gurudwara Based                       */
  /* -------------------------------------------------------------------------- */
  async donationGet({ commit }, params) {
    commit('SET_STATE', {
      action: 'donationListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${DONATION_PREFIX}/list`, { params })
      commit('SET_STATE', {
        action: 'donationListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'donationRecords',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'donationTotal',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'donationFilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'donationListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Donation Delete                               */
  /* -------------------------------------------------------------------------- */
  async donationDelete({ commit }, id) {
    commit('SET_STATE', {
      action: 'donationListLoading',
      data: true
    })
    try {
      const res = await this.$http.delete(`/${DONATION_PREFIX}/delete/${id}`)
      commit('SET_STATE', {
        action: 'donationListLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'donationListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                 Donation Bulk Delete                           */
  /* -------------------------------------------------------------------------- */
  async donationBulkDelete({ commit }, donation) {
    commit('SET_STATE', {
      action: 'donationListLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`/${DONATION_PREFIX}/multi-delete`, donation)
      commit('SET_STATE', {
        action: 'donationListLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'donationListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Donation Update                               */
  /* -------------------------------------------------------------------------- */
  async donationUpdate({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${DONATION_PREFIX}/update/${id}`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                              Get Detail Donation                              */
  /* -------------------------------------------------------------------------- */
  async donationShow({ commit }, id) {
    commit('SET_STATE', {
      action: 'donationListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${DONATION_PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'donationListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'donationRecord',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'donationListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                           Gurudwara Admin List                             */
  /* -------------------------------------------------------------------------- */
  async getGurudwaraAdmin({ commit }, params) {
    commit('SET_STATE', {
      action: 'adminListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`admin/organization/admin-list`, { params })
      commit('SET_STATE', {
        action: 'adminListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'adminRecords',
        data: res.data.data
      })
      commit('SET_STATE', {
        action: 'adminTotal',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'adminFilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'adminListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                           Revoke access user                               */
  /* -------------------------------------------------------------------------- */
  async revokeAccessUser({ commit }, { organizationId, userId }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put(`admin/organization/revoke-admin-access/${organizationId}/${userId}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                        list updates Gurudwara Based                       */
  /* -------------------------------------------------------------------------- */
  async updateGet({ commit }, params) {
    commit('SET_STATE', {
      action: 'updateListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${UPDATE_PREFIX}`, { params })
      commit('SET_STATE', {
        action: 'updateListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'updateRecords',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'updateTotal',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'updateFilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'updateListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Update Delete                               */
  /* -------------------------------------------------------------------------- */
  async updateDelete({ commit }, id) {
    commit('SET_STATE', {
      action: 'updateListLoading',
      data: true
    })
    try {
      const res = await this.$http.delete(`/${UPDATE_PREFIX}/delete/${id}`)
      commit('SET_STATE', {
        action: 'updateListLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'updateListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Update Update                               */
  /* -------------------------------------------------------------------------- */
  async updateCreateOrUpdate({ commit }, { data }) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${UPDATE_PREFIX}/create-or-edit`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                              Get Detail Update                              */
  /* -------------------------------------------------------------------------- */
  async updateShow({ commit }, id) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: false
    })
    try {
      const res = await this.$http.get(`${UPDATE_PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'updateRecord',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                          Toggle Pin/Unpin Update                          */
  /* -------------------------------------------------------------------------- */
  async togglePinUpdate({ commit }, id) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`/${UPDATE_PREFIX}/change-pinned/${id}`)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                        list updates Gurudwara Based                       */
  /* -------------------------------------------------------------------------- */
  async membersGet({ commit }, params) {
    commit('SET_STATE', {
      action: 'memberListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${MEMBER_PREFIX}/list`, { params })
      commit('SET_STATE', {
        action: 'memberListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'memberRecords',
        data: res.data.data.results
      })
      commit('SET_STATE', {
        action: 'memberTotal',
        data: res.data.data.totalResults
      })
      commit('SET_STATE', {
        action: 'memberFilteredCount',
        data: res.data.data.totalResults
      })
    } catch (error) {
      commit('SET_STATE', {
        action: 'memberListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  async membrShow({ commit }, id) {
    commit('SET_STATE', {
      action: 'memberListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${MEMBER_PREFIX}/details/${id}`)
      commit('SET_STATE', {
        action: 'memberListLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'donationRecord',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'memberListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Create Member                                */
  /* -------------------------------------------------------------------------- */
  async createMember({ commit }, data) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.post(`${MEMBER_PREFIX}/create`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        message: res.data.message,
        data: res.data.data
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Update Member                                */
  /* -------------------------------------------------------------------------- */
  async updateMember({ commit }, { id, data }) {
    commit('SET_STATE', {
      action: 'createLoading',
      data: true
    })
    try {
      const res = await this.$http.put(`${MEMBER_PREFIX}/update/${id}`, data)
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'createLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                               Show Member                                  */
  /* -------------------------------------------------------------------------- */
  async memberShow({ commit }, id) {
    commit('SET_STATE', {
      action: 'listLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${MEMBER_PREFIX}/single-member/${id}`)
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'record',
        data: res.data.data
      })
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'listLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  }
}
